export enum SectionType {
  CONTENT = 1,
  LIST = 2,
}

type SectionBase = {
  key: string;
  type: SectionType;
  link?: string;
  buttonAction?: () => void;
  hasNote?: boolean;
};

type SectionContent = SectionBase & {
  type: SectionType.CONTENT;
};

type SectionList = SectionBase & {
  type: SectionType.LIST;
  itemsCount: number;
  isUnordered?: boolean;
};

export type Section = SectionContent | SectionList;
